module.exports = __webpack_public_path__ + "img/travolta.304b31d.png";